<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel" style="">
				<div class="NButton DIVNoSelect" style="width:70px; margin-top:-1px; margin-left:10px;" @click="onFeeAddClick">新增</div>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">开始时间</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="sYmd">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">结束时间</div>
				<input type="text" style="width:120px;" maxlength=10 v-model="eYmd">

				<input type="text" style="width:80px; margin-left:10px;" maxlength=6 v-model="devoCode" placeholder="授权码">

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onRechListClick"></div>

				<div style="flex:1 0 auto;"></div>
				<div class="OPItem" style="flex:0 0 auto; height:50px; line-height:50px; padding-right:20px;" @click="onDevRech">设备续费</div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'aiRech',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			devoCode: "",                       // 授权码
			keyFind: 1000,
			sYmd: "",                               // 开始时间
			eYmd: "",                               // 结束时间
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:['共', '条记录,', '页', '条/页', '页码','Go'],
				qryFunc: this.onRechListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 370,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: this.onRechListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:"客户", width:300 },
					],
					head2:[                         // 数据列表头
						{ width:200, capt:'时间' },
						{ width:150, capt:'续费前余额' },
						{ width:150, capt:'续费金额' },
						{ width:150, capt:'续费后余额' },
						{ width:120, capt:'状态' },
						{ width:220, capt:'销售' },
						{ width:100, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:'操作', width:80 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		this.sYmd = this.getDTStr( 1, 0, 0, 0 );
		this.eYmd = this.getDTStr( 1, 0, 0, 0 );

		if( !parseInt(this.login.userId) ) return;

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onRechListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 跳转到设备续费 */
		onDevRech: function(){
			this.$router.push( "/FrameBody/feeMgr" );
		},
		/* 添加按钮事件响应 */
		onFeeAddClick: function( ){
			this.ctrlWin.w2 = 600;
			this.ctrlWin.h2 = 370;
			this.ctrlWin.captCont = "添加AI续费信息";
			this.ctrlWin.vuepath = "/FrameBody/aiRech/airNew";
			this.ctrlWin.info=null;
			this.ctrlWin.self.onShow();
		},
		/* 查询按钮事件响应 */
		onRechListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1,
						startYmd: this.sYmd, endYmd:this.eYmd,  };

			this.doTrade( "POST", ServAddr+"/api/rec/aiRechQry", this.onRechListOK, true, body, null );
		},
		onRechListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.list.length; i++ )
			{
				let item=data.body.list[i];
				this.ctrlTable.datas.data1.push([ item.custName ]);

				this.ctrlTable.datas.data2.push( [ 	item.carAddDatetime.substring(0,19),
													"$"+(item.carPreMoney/100).toFixed(2),
													"$"+(item.carBuyMoney/100).toFixed(2),
													"$"+(item.carAftMoney/100).toFixed(2),
													this.getListTextByValue( this.dataRechargeSts, item.carApplySts ),
													item.carSaler, '' ] );
				let op1={};
				let op2={};
				let op3={};
				if( this.login.userId == gPlatUserId )
				{
					if( item.carApplySts == 1 )
					{
						op1={capt:  "编辑", clk:this.onEditClick, param:item};
						op2={capt:  "删除", clk:this.onDeleClick, param:item};
						op3={capt:  "执行", clk:this.onApplyClick, param:item};
					}
					else
					{
						op1={capt:  "编辑", clk:null, param:item};
						op2={capt:  "删除", clk:null, param:item};
						op3={capt:  "执行", clk:null, param:item};
					}
				}
				else
				{
					op1={capt:  "编辑", clk:null, param:item};
					op2={capt:  "删除", clk:null, param:item};
					op3={capt:  "执行", clk:null, param:item};
				}

				this.ctrlTable.datas.data3.push([ [ op2, op3 ] ]);
			}

			if( this.login.custId == gPlatCustId )
				 this.ctrlTable.dataHeads.head3[0].width = 150;
			else this.ctrlTable.dataHeads.head3[0].width = 80;

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
		/* 编辑按钮事件响应 */
		onEditClick: function( param ){
			this.ctrlWin.w2 = 600;
			this.ctrlWin.h2 = 370;
			this.ctrlWin.captCont = "修改AI续费信息";
			this.ctrlWin.vuepath = "/FrameBody/aiRech/airNew";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 删除按钮事件响应 */
		onDeleClick: function( param ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, "警告", "确定要删除吗？", "", { okFunc: this.onRechargeDelDo, okParam:param } );
		},
		onRechargeDelDo: function( param ){
			let par="?carId="+param.carId;
			this.doTrade( "DELETE", ServAddr+"/api/aiRecharge/aiFeeDel"+par, this.onRechListClick, true, null, null );
		},
		/* 执行续费 */
		onApplyClick: function( param ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, "警告", "确定要续费吗", "", { okFunc: this.onRechargeExcuteDo, okParam:param } );
		},
		onRechargeExcuteDo: function( param ){
			let body={ carId: param.carId, devoCode:this.devoCode };

			this.doTrade( "POST", ServAddr+"/api/aiRecharge/aiFeeApply", this.onRechargeExcuteDoOK, true, body, null );
		},
		onRechargeExcuteDoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, "续费失败", this.CLR.Err );
				return;
			}
			this.onRechListClick();
		}
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// aiRech.vue?c799f2ae